var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFlashOff = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_flash_off",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .flash-off-class-a {\n        fill: none !important;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2287",
    className: "flash-off-class-a",
    "data-name": "Rectangle 2287",
    width: 24,
    height: 24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-flash-off",
    "data-name": "Icon ionic-ios-flash-off",
    transform: "translate(0.005 0.503)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M17.347,19.875,7.183,2.563a.643.643,0,0,0-.871-.228.625.625,0,0,0-.228.862L16.248,20.514a.633.633,0,0,0,.549.313.654.654,0,0,0,.322-.085A.638.638,0,0,0,17.347,19.875Z",
    transform: "translate(-0.002 -0.036)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M15.1,14.488,17.685,11.1a.377.377,0,0,0-.281-.6H12.759Z",
    transform: "translate(-0.327 -0.427)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M14.811,1.728a.18.18,0,0,0-.322-.152L10.641,6.631l1.893,3.229Z",
    transform: "translate(-0.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M8.652,9.314,6.067,12.7a.377.377,0,0,0,.281.6h4.64Z",
    transform: "translate(0 -0.37)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M8.981,21.857a.18.18,0,0,0,.322.152l3.849-5.055-1.893-3.229Z",
    transform: "translate(-0.141 -0.59)",
    fill: "#fff"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlashOff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/FlashOff.26c10638e5e963a37c40657ee259b19f.svg";